export default {
    
    //测试环境接口地址 appid
    api2:process.env.NODE_ENV === "production"?`https://gateway.starpos.com.cn/estwechat/`:`http://sandbox.starpos.com.cn/estwechat/`, // 商户信息登记
    api: process.env.NODE_ENV === "production"?`https://gateway.starpos.com.cn/estmadp2/`:`https://sandbox.starpos.com.cn/estmadp2/`, //台牌进件接口地址http://139.196.141.163:8302/estmapp/
    AxqApi: process.env.NODE_ENV === "production"?`https://gateway.starpos.com.cn/epsns`:`http://sandbox.starpos.com.cn/epsns`, //安心签接口地址
    AxqApi2: process.env.NODE_ENV === "production"?`https://gateway.starpos.com.cn/epmaaxq/`:`http://sandbox.starpos.com.cn/epmaaxq/`, //商户信息登记安心签接口地址
    imgApi: process.env.NODE_ENV === "production"?`https://gateway.starpos.com.cn/`:`http://sandbox.starpos.com.cn/`, //图片上传和回显地址http://139.196.141.163:8480/
    appId: process.env.NODE_ENV === "production"?`wxb607df8e145dc9a4`:`wx9da07c3fb189d02e`, //微信公众号appid
    appSecret: process.env.NODE_ENV === "production"?`6923a90d353f3d67058ce1142a94e00d`:`1e6e494de2166d4be18e6bb5455fc949`, //微信公众号appsecret
    redirect_uri: process.env.NODE_ENV === "production"?`https://website.starpos.com.cn/panasonic/supercode/guide`:`http://bystages-test.starpos.com.cn/panasonic/supercode/guide`, //微信公众号会调地址
    myApi: process.env.NODE_ENV === "production"?`https://website.starpos.com.cn`:`http://bystages-test.starpos.com.cn`, //页面地址
    V: process.env.NODE_ENV === "production"?`&V=1.0.1`:`&V=1.0.1`, //页面地址
    // YPlan小程序
    Yapi:process.env.NODE_ENV === "production"?`https://dividend.starpos.com.cn/sharGetInfo`:`https://dividend-test.starpos.com.cn/sharGetInfo`, // OCR接口地址
    // YPlan进件
    // yPlay:process.env.NODE_ENV === "production"?`https://order.starpos.com.cn/workorder/yplay/`:`http://192.168.10.223:8080/workorder/yplay/`,
    yPlay:process.env.NODE_ENV === "production"?`https://order.starpos.com.cn/workorder/yplay/`:`https://test.starpos.com.cn/workorder/yplay/`,

    ossData:process.env.NODE_ENV === "production" ?{
        region: "oss-cn-shanghai", //换成你自己的
        accessKeyId: "LTAIckedwbl29wVq",
        accessKeySecret: "02AMz9pKFN5wAbV31Rk7WuDyNKpJeD",
        bucket: "filesystem-prod", //bucket名字
        secure: true
      }:{
        region: "oss-cn-shanghai", //换成你自己的
        accessKeyId: "LTAIlzp3l8jBctcH",
        accessKeySecret: "3Na6YcJzpt0AopS6FeijAbNhQs5KlR",
        bucket: "test-filesystem", //bucket名字
        secure: true
      },
    ossUrl:process.env.NODE_ENV === "production"?`https://filesystem-prod.oss-cn-shanghai.aliyuncs.com/`:`http://test-filesystem.oss-cn-shanghai.aliyuncs.com/`,
    // //生产环境接口地址 appid
    // api: `https://gateway.starpos.com.cn/estmadp2/`, //台牌进件接口地址
    // AxqApi: `https://gateway.starpos.com.cn/epsns`, //安心签接口地址
    // imgApi: `https://gateway.starpos.com.cn/`, //图片上传和回显地址
    // appId: `wxb607df8e145dc9a4`, //微信公众号appid
    // appSecret: `6923a90d353f3d67058ce1142a94e00d`, //微信公众号appsecret
    // redirect_uri: `https://website.starpos.com.cn/panasonic/supercode/guide`, //微信公众号会调地址
    // myApi: `https://website.starpos.com.cn` //页面地址

}


// WEBPACK FOOTER //
// ./src/api/api.js